import Config from 'config'
import HttpProvider from '@/services/HttpProvider'
import { restWithCache } from '@/store/lib/search'
import { ordersList, getOrderById } from './graphQlquery/orders'
import { setPickupIdOnCart, getPickupLocationIdFromCode, getStorePickupByCountry, getStoreLocatorConfig } from './graphQlquery/storePickup'
import { addGiftCardOnCart } from './graphQlquery/giftCardCart'
import graphListing from './graphQlquery/listing'
import graphProduct from './graphQlquery/product'
import productConfigurable from './graphQlquery/productConfigurable'
import graphCart from './graphQlquery/cart'
import blogCategories from './graphQlquery/blogCategories'
import blogCategory from './graphQlquery/blogCategory'
import graphCustomer from './graphQlquery/customer'
import updateCustomer from './graphQlquery/updateCustomer'
import rmaList from './graphQlquery/rmaList'
import rmaDetail from './graphQlquery/rmaDetail'
import rmaOrdersAvailable from './graphQlquery/rmaOrdersAvailable'
import checkGuestOrder from './graphQlquery/checkGuestOrder'
import rmaNewPrepare from './graphQlquery/rmaNewPrepare'
import rmaCreate from './graphQlquery/rmaCreate'
import cardList from './graphQlquery/cardList'
import cardDisable from './graphQlquery/cardDisable'
import urlResolve from './graphQlquery/urlResolve'
import storeConfig from './graphQlquery/storeConfig'
import suggestionsProduct from './graphQlquery/suggestionsProduct'
import mergeCarts from './graphQlquery/mergeCarts'
import customerCart from './graphQlquery/customerCart'
import customerChangePassword from './graphQlquery/customerChangePassword'
import unsubscribeEmail from './graphQlquery/unsubscribeEmail'
import categoryById from './graphQlquery/categoryById'
import variantExt from './graphQlquery/variantExt'
import vaultManagement from './graphQlquery/vaultManagement'

const graphSchema = {
  graphListing,
  graphProduct,
  productConfigurable,
  blogCategories,
  blogCategory,
  ordersList,
  getOrderById,
  graphCart,
  graphCustomer,
  updateCustomer,
  rmaList,
  rmaDetail,
  rmaOrdersAvailable,
  checkGuestOrder,
  rmaNewPrepare,
  rmaCreate,
  cardList,
  cardDisable,
  urlResolve,
  storeConfig,
  suggestionsProduct,
  mergeCarts,
  customerCart,
  addGiftCardOnCart,
  customerChangePassword,
  unsubscribeEmail,
  categoryById,
  variantExt,
  setPickupIdOnCart,
  getPickupLocationIdFromCode,
  getStorePickupByCountry,
  getStoreLocatorConfig,
  vaultManagement
}

if (Config.Theme.extGraph) {
  const extGraphJS = require.context('theme/services/graphQlquery', false, /.js$/i)
  extGraphJS.keys().forEach(key => {
    graphSchema[Config.Theme.extGraph[key]] = extGraphJS(key).default
  })
}
class Graphql {
  // constructor () { }
  toGraphQlFilter (jsonObj) {
    let convertedStr = ''
    let value
    for (var key in jsonObj) {
      value = typeof jsonObj[key] === 'object' && !Array.isArray(jsonObj[key]) ? `{${this.toGraphQlFilter(jsonObj[key])}}` : JSON.stringify(jsonObj[key])
      convertedStr += `${key}:${value},`
    }
    return convertedStr.slice(0, -1)
  }

  parserGraphQl (filter) {
    return this.toGraphQlFilter(filter)
      .replace(':"DESC"', ':DESC')
      .replace(':"ASC"', ':ASC')
  }

  genericCall (config, token, storeViewCode, graphSchemaType, variables = null, useCache = true, option = null) {
    let query = option && option.query ? option.query : graphSchema[graphSchemaType]
    for (var key in config) {
      query = query.replace(`{{${key}}}`, this.parserGraphQl(config[key]))
    }
    return this.doCall(query, variables, token, storeViewCode, useCache)
  }

  // CART MUTATION
  addCouponOnCart (cartID, couponCode, token, storeViewCode) {
    let query = graphCart.addCoupon()
    let variables = {
      input: {
        cart_id: cartID,
        coupon_code: couponCode
      }
    }
    return { query, variables, token, storeViewCode }
    // doCall on page src\theme\components\Checkout\Cart\Coupon.vue
  }

  removeCouponFromCart (cartID, token, storeViewCode) {
    let query = graphCart.removeCoupon()
    let variables = {
      input: {
        cart_id: cartID
      }
    }
    return { query, variables, token, storeViewCode }
    // doCall on page src\theme\components\Checkout\Cart\Coupon.vue
  }

  doCall (query, variables = null, token, storeViewCode, useCache = true) {
    let config = {
      headers: {
        'Authorization': '',
        'Store': storeViewCode
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // useCache on call for GET request
    // do not use cache when request need a data update
    if (useCache) {
      return restWithCache({
        query: { header: config.headers },
        body: { query, variables, storeViewCode },
        restPromise: HttpProvider.post(Config.API.graphql, { query, variables }, config)
      })
    } else {
      return HttpProvider.post(Config.API.graphql, { query, variables }, config).then(res => res.data)
    }
  }

  genericCallCash ({ token, storeViewCode, graphSchemaType, variables, useCache = true, useInlineQuery = false }) {
    let query = useInlineQuery || graphSchema[graphSchemaType].replace(/(\s){2,}/g, ' ')
    return this.graphCash({ query, variables, token, storeViewCode, useCache, id: graphSchemaType })
  }

  graphCash ({ query, variables, token, storeViewCode, useCache }) {
    let config = {
      headers: {
        'Authorization': '',
        'Store': storeViewCode
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // useCache on call for GET request
    // do not use cache when request need a data update
    if (useCache) {
      return restWithCache({
        query: { header: config.headers },
        body: { query, variables, storeViewCode },
        restPromise: HttpProvider.post(Config.API.graphql + '?usecache=true', { query, variables }, config)
      })
    } else {
      return HttpProvider.post(Config.API.graphql + '?usecache=true', { query, variables }, config).then(res => res.data)
    }
  }
}

const instanceGraph = new Graphql()

export default instanceGraph
